import { getCatalogAppIdsV1, getItemsCountV1, getItemTypesV1 } from '../utils/cart/bi.utils';
var BIService = /** @class */ (function () {
    function BIService(_a) {
        var siteStore = _a.siteStore, origin = _a.origin;
        this.siteStore = siteStore;
        this.origin = origin;
    }
    BIService.prototype.updateCartItemQuantityV1 = function (_a) {
        var origin = _a.origin, cart = _a.cart;
        return this.siteStore.platformBiLogger.updatedCartItemQuantitySf({
            origin: origin !== null && origin !== void 0 ? origin : this.origin,
            itemsCount: getItemsCountV1(cart.lineItems),
            cartId: cart._id,
            catalogAppId: getCatalogAppIdsV1(cart.lineItems),
            checkoutId: cart.checkoutId,
            purchaseFlowId: cart.purchaseFlowId,
        });
    };
    BIService.prototype.removeCouponV1 = function (_a) {
        var _b, _c;
        var origin = _a.origin, discounts = _a.discounts, cart = _a.cart;
        var coupon = (_b = discounts === null || discounts === void 0 ? void 0 : discounts.find(function (discount) { return discount.coupon; })) === null || _b === void 0 ? void 0 : _b.coupon;
        return this.siteStore.platformBiLogger.removeACoupon({
            origin: origin !== null && origin !== void 0 ? origin : this.origin,
            cartId: cart._id,
            couponCode: coupon === null || coupon === void 0 ? void 0 : coupon.code,
            catalogAppId: getCatalogAppIdsV1(cart.lineItems),
            checkoutId: (_c = cart.checkoutId) !== null && _c !== void 0 ? _c : undefined,
            itemType: getItemTypesV1(cart.lineItems),
        });
    };
    BIService.prototype.applyCouponV1 = function (_a) {
        var origin = _a.origin, couponCode = _a.couponCode, cart = _a.cart;
        return this.siteStore.platformBiLogger.clickApplyCoupon({
            origin: origin,
            couponCode: couponCode,
            catalogAppId: getCatalogAppIdsV1(cart.lineItems),
            checkoutId: cart.checkoutId,
            itemType: getItemTypesV1(cart.lineItems),
        });
    };
    BIService.prototype.removeLineItemV1 = function (_a) {
        var cart = _a.cart, origin = _a.origin;
        return this.siteStore.platformBiLogger.removedProductFromCartSf({
            cartId: cart._id,
            origin: origin !== null && origin !== void 0 ? origin : this.origin,
            itemsCount: getItemsCountV1(cart.lineItems),
            catalogAppId: getCatalogAppIdsV1(cart.lineItems),
            checkoutId: cart.checkoutId,
            purchaseFlowId: cart.purchaseFlowId,
        });
    };
    return BIService;
}());
export { BIService };
//# sourceMappingURL=BIService.js.map